export const semanticClassNames = {
  root: 'menu',
  item: 'menu__item',
  itemLabel: 'menu__item-label',
  scrollButton: 'menu__scroll-button',
  scrollButtonIcon: 'menu__scroll-button-icon',
  itemIcon: 'menu__item-icon',
} as const;

// TODO: Change it once we finish the migration from SHM to the New menu
export default {};
